import config from '../../config';
import { proxyPasswordReset } from '../../util/api';
import { storableError } from '../../util/errors';
import { logError } from '../../util/log';

// ================ Action types ================ //

export const RESET_PASSWORD_REQUEST = 'app/PasswordResetPage/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'app/PasswordResetPage/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'app/PasswordResetPage/RESET_PASSWORD_ERROR';

// ================ Reducer ================ //

/** @type {import('../../../types/vansite').VanSite.State.PasswordResetPage} */
const initialState = {
  resetPasswordInProgress: false,
  resetPasswordError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case RESET_PASSWORD_REQUEST:
      return { ...state, resetPasswordInProgress: true, resetPasswordError: null };
    case RESET_PASSWORD_SUCCESS:
      return { ...state, resetPasswordInProgress: false };
    case RESET_PASSWORD_ERROR:
      return { ...state, resetPasswordInProgress: false, resetPasswordError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const resetPasswordRequest = () => ({ type: RESET_PASSWORD_REQUEST });

export const resetPasswordSuccess = () => ({ type: RESET_PASSWORD_SUCCESS });

export const resetPasswordError = (e) => ({
  type: RESET_PASSWORD_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const resetPassword =
  (email, passwordResetToken, newPassword) => (dispatch, getState, sdk) => {
    dispatch(resetPasswordRequest());
    const params = { email, passwordResetToken, newPassword };
    // marketplace-web@P1: hinter dem Flag läuft der Reset-Confirm über das BFF
    // (dual-write in Sharetribe UND vansite-auth), sonst unverändert per SDK.
    const doReset = config.proxyLoginEnabled
      ? proxyPasswordReset(params)
      : sdk.passwordReset.reset(params);
    return doReset
      .then(() => dispatch(resetPasswordSuccess()))
      .catch((e) => {
        logError(e, 'password-reset-failed', { email });
        dispatch(resetPasswordError(storableError(e)));
      });
  };
